import { Columns } from '@shared/interfaces/table/column-config';
import {MeterDto} from '@app/api/nts';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const meterQuadrantMasterData: Columns<MeterDto>[] = [
  {
    title: 'A14',
    key: 'mappingA14',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.quadrantTypes.NotSpecified',
      consumption: 'meter.quadrantTypes.Consumption',
      production: 'meter.quadrantTypes.Production',
      reactivepositive: 'meter.quadrantTypes.ReactivePositive',
      reactivenegative: 'meter.quadrantTypes.ReactiveNegative',
    }
  },
  {
    title: 'A23',
    key: 'mappingA23',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.quadrantTypes.NotSpecified',
      consumption: 'meter.quadrantTypes.Consumption',
      production: 'meter.quadrantTypes.Production',
      reactivepositive: 'meter.quadrantTypes.ReactivePositive',
      reactivenegative: 'meter.quadrantTypes.ReactiveNegative',
    }
  },
  {
    title: 'R12',
    key: 'mappingR12',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.quadrantTypes.NotSpecified',
      consumption: 'meter.quadrantTypes.Consumption',
      production: 'meter.quadrantTypes.Production',
      reactivepositive: 'meter.quadrantTypes.ReactivePositive',
      reactivenegative: 'meter.quadrantTypes.ReactiveNegative',
    }
  },
  {
    title: 'R34',
    key: 'mappingR34',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.quadrantTypes.NotSpecified',
      consumption: 'meter.quadrantTypes.Consumption',
      production: 'meter.quadrantTypes.Production',
      reactivepositive: 'meter.quadrantTypes.ReactivePositive',
      reactivenegative: 'meter.quadrantTypes.ReactiveNegative',
    }
  }
]
